// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../../lib/pureComponent'
import type { FactProps } from '../../types'
import styles from './Fact.css'

type Props = {
  factBox: FactProps
}

export class FactBox extends PureComponent<Props, {}> {
  render() {
    const { factBox } = this.props
    const { factTitle, factText } = factBox

    if (factText === '') {
      return null
    }
    return (
      <div>
        <div className={`${styles['fact-wrapper__content']}`}>
          <h3>{factTitle}</h3>
          <div dangerouslySetInnerHTML={{ __html: factText }} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/FactBox/Fact.js